import environment from "../env";
import { initiatePaymentSchema } from "../graphql/mutations/initiatePayment";
import { MutationResult, useMutation } from "@apollo/client";
import { totalCheckoutAmount } from "../store/nanostore";

interface UserIdentify {
  email?: string;
  phoneNumber?: string;
}

interface PaymentPayload {
  amount: number;
  emailOrPhone: UserIdentify;
  requestId?: string;
  tokenId: string;
}

export const useMakePayment = () => {
  const variables = {
    variables: { ...environment.paymentService },
  };
  const [initiate, request] = useMutation(initiatePaymentSchema, variables);

  const makePayment = (input: PaymentPayload) => {
    input.requestId = input.requestId || Date.now().toString();
    input.emailOrPhone = {
      email: input.emailOrPhone.email,
      phoneNumber: input.emailOrPhone.phoneNumber,
    };
    input.amount = totalCheckoutAmount.get();
    initiate({ variables: { input } });
  };

  return [request, makePayment] as [MutationResult<any>, typeof makePayment];
};
